import { IIconProps } from "@/models";
import { SvgIcon } from "@mui/material";
import { memo } from "react";

const DesktopQuestion = ({ sx, ...otherProps }: IIconProps) => {
  return (
    <SvgIcon
      viewBox="0 0 24 25"
      sx={{ fontSize: "inherit", fill: "none", ...sx }}
      {...otherProps}
    >
      <path
        d="M13.5 16.3252H4C3.73478 16.3252 3.48043 16.2198 3.29289 16.0323C3.10536 15.8448 3 15.5904 3 15.3252V5.3252C3 5.05998 3.10536 4.80563 3.29289 4.61809C3.48043 4.43055 3.73478 4.3252 4 4.3252H20C20.2652 4.3252 20.5196 4.43055 20.7071 4.61809C20.8946 4.80563 21 5.05998 21 5.3252V11.8252M7 20.3252H15M9 16.3252V20.3252M19 22.3252V22.3352M19 19.3252C19.4483 19.3238 19.8832 19.172 20.235 18.8941C20.5868 18.6163 20.8352 18.2285 20.9406 17.7927C21.0459 17.357 21.0019 16.8985 20.8158 16.4906C20.6297 16.0828 20.3122 15.7492 19.914 15.5432C19.5162 15.3394 19.0611 15.2762 18.6228 15.3639C18.1845 15.4516 17.7888 15.685 17.5 16.0262"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
};

export default memo(DesktopQuestion);
